// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__lQpox","deleteIcon":"styles_deleteIcon__WPai7"};